import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { useThemeStore, applyThemeAttribute } from './store/themeStore'
import './styles/global.css'

// Vor dem ersten Render anwenden (kein Flash des falschen Themes) und bei jeder
// Änderung live nachziehen, ohne dass Komponenten selbst darauf achten müssen.
applyThemeAttribute(useThemeStore.getState().theme)
useThemeStore.subscribe((state) => applyThemeAttribute(state.theme))

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root-Element #root nicht gefunden')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
